import { FirestoreCollections } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';

export type GetUserDocOptions<TDocRef = unknown, TDb = FirestoreInstance> = {
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  userId: string;
};

export const getUserDoc = <TDocRef, TDb = FirestoreInstance>(
  options: GetUserDocOptions<TDocRef, TDb>,
): TDocRef => {
  const { db, doc, userId } = options;
  return doc(db, FirestoreCollections.Users, userId);
};
